@import '../../../utils/global.module.less';

.header {
    padding: 16px var(--main-container-side-padding);
    background: #F9FAFB;
    margin-bottom: 10px;
    margin-top: 30px;
}

.searchBar {
    gap: 12px;
    align-items: center;
    height: 40px;
    justify-content: space-between;
}

.leftGroup {
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    
    @media (min-width: 1400px) {
        gap: 16px;
    }
    
    @media (min-width: 1600px) {
        gap: 20px;
    }
}

.rightGroup {
    display: flex;
    align-items: center;
}

.divider {
    color: #d1d5db;
    font-size: 18px;
    margin: 0 8px;
    user-select: none;
    height: 40px;
    display: flex;
    align-items: center;
    border-right: 1px solid #d1d5db;
    padding: 0;
    width: 1px;
}

.searchWrapper {
    position: relative;
    width: 200px;
    height: 40px;
    background: white;
    border-radius: 8px;
    
    @media (min-width: 1400px) {
        width: 240px;
    }
    
    @media (min-width: 1600px) {
        width: 280px;
    }

    .searchIcon {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.search {
    width: 100%;
    height: 40px;
    padding: 0 32px 0 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 14px;
    background: white;
    line-height: 40px;
    display: flex;
    align-items: center;

    &::placeholder {
        color: #666;
    }

    &:focus {
        outline: none;
        border-color: #4a90e2;
    }
}

.industrySearch, .scoreSearch, .sortWrapper {
    position: relative;
    min-width: 180px;
    height: 40px;
    background: white;
    border-radius: 8px;

    :global(.rbt) {
        width: 100%;
        height: 40px;
    }

    :global(.rbt-input-wrapper) {
        padding: 0;
        height: 40px;
        display: flex;
        align-items: center;
    }

    :global(.rbt-input) {
        height: 40px;
        padding: 0 32px 0 12px;
        border: 1px solid #ddd;
        border-radius: 8px;
        font-size: 14px;
        background: white;
        line-height: 40px;
        display: flex;
        align-items: center;

        &::placeholder {
            color: #666;
        }

        &:focus {
            outline: none;
            border-color: #4a90e2;
        }
    }

    :global(.rbt-input-multi) {
        padding: 0 32px 0 12px;
        min-height: 40px;
        height: 40px;
        display: flex;
        align-items: center;
    }

    :global(.rbt-token) {
        font-size: 14px;
        height: 30px !important;
        margin: 1px 4px 2px 0 !important;
        display: flex !important;
        align-items: center !important;
        background-color: #F1F7FE !important;
        border: 1px solid #9DBFFD !important;
        border-radius: 6px !important;
        color: #102442 !important;
        font-weight: 500 !important;
        padding: 2px 4px 2px 2px !important;
        line-height: 1 !important;
    }

    :global(.rbt-token-remove-button) {
        color: #102442 !important;
        font-weight: 700 !important;
        border: none !important;
        background: transparent !important;
        margin-top: -1px !important;
        margin-left: 4px !important;
        font-size: 21px !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: 18px !important;
        height: 18px !important;
        padding: 0 !important;
        line-height: 1 !important;
        
        &:hover {
            color: #4285f4 !important;
        }
    }

    .dropdownIcon {
        position: absolute;
        right: 8px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}

.industrySearch {
    width: 450px;
    
    @media (min-width: 1400px) {
        width: 500px;
    }
    
    @media (min-width: 1600px) {
        width: 600px;
    }
    
    @media (min-width: 1800px) {
        width: 700px;
    }
    
    @media (max-width: 1200px) {
        width: 380px;
    }
    
    @media (max-width: 768px) {
        width: 280px;
    }
}

.scoreSearch {
    width: 150px;
    
    @media (min-width: 1400px) {
        width: 170px;
    }
    
    @media (min-width: 1600px) {
        width: 190px;
    }
    
    @media (max-width: 768px) {
        width: 120px;
    }
}

.sortWrapper {
    width: 127px;
    
    @media (max-width: 768px) {
        width: 100px;
    }
}

.sortSelect {
    width: 100%;
    height: 40px;
    
    :global(.rbt) {
        width: 100%;
        height: 40px;
    }

    :global(.rbt-input) {
        height: 40px;
        padding: 0 32px 0 12px;
        border: 1px solid #ddd;
        border-radius: 8px;
        font-size: 14px;
        background: white;
        line-height: 40px;
        display: flex;
        align-items: center;

        &::placeholder {
            color: #666;
        }

        &:focus {
            outline: none;
            border-color: #4a90e2;
        }
    }
}

.resetButton {
    padding: 0 16px;
    background: none;
    border: none;
    color: #133971;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
    height: 40px;
    line-height: 40px;
    display: flex;
    align-items: center;

    &:hover {
        text-decoration: underline;
    }
}

.selected {
    background-color: #e8f0fe;
    color: #007bff;
    font-weight: bold;
}

.dealCount {
    margin: 16px 0 0 0;
    color: #475467;
    font-size: 14px;
    padding: 0;
}
